import { Literature, LiteratureCategory } from '@/shared/MwsViewModels';
import { Mixins, Component, Prop } from 'vue-property-decorator';
import template from './literature-library-results.vue';
import GenericLink from '../../../../shared/components/link/GenericLink';
import Translatable from '../../../../translation/Translatable';
import LiteratureOrderMixin from '../../../../shared/literature-order/LiteratureOrderMixin';

@Component({
  mixins: [template],
  components: {
    GenericLink,
  },
})
export default class LiteratureLibraryResults extends Mixins(Translatable, LiteratureOrderMixin) {
  @Prop()
  data: LiteratureCategory[];

  private afterSearch: boolean = false;

  beforeUpdate() {
    this.afterSearch = true;
  }

  order(document: Literature): void {
    this.addLiteratureId(document.id);
  }
}
